import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-input-with-spinner',
    templateUrl: './input-with-spinner.component.html',
    styleUrls: ['./input-with-spinner.component.scss'],
    standalone: false
})
export class InputWithSpinnerComponent implements OnInit {

  @Input() inputLabel: string;
  constructor() { }

  ngOnInit() {
  }

}
